import React from 'react'
import Button from './Button'
import classes from './Buttons.module.css'
import { AccessibilityHidden } from '@skillz/accessibility';

const FillBGBtn = ({ onClick, backgroundColor, children, small, medium, large, boxShadow, report, dropClass, color, isBtn, accessibilityDescription }) => {

    const handleclick = (e) => {
        onClick && onClick()
    }

    return (
        <Button
            className={`${classes.Btn} ${classes.FillBGBtn} ${small && classes.Small} ${medium && classes.Medium} ${large && classes.Large} ${boxShadow && classes.BoxShadow} ${dropClass}`}
            onClick={(e) => handleclick(e)}
            dropStyle={{ background: backgroundColor, color: color }}
            report={report}
            isBtn={isBtn}
            accessibilityDescription={accessibilityDescription}>
            {children}
            <AccessibilityHidden>
                <svg style={{ transform: "rotate(180deg)", display: 'flex' }} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <ellipse cx="12.008" cy="12.0001" rx="12.0001" ry="12.008" transform="rotate(-90 12.008 12.0001)" fill="transparent" />
                    <path d="M6.47266 17.8077L12.4766 11.8521L6.47266 6.1947" stroke={color || "white"} strokeWidth="2" strokeLinecap="round" />
                    <path d="M12.3359 17.8077L18.3399 11.8521L12.3359 6.1947" stroke={color || "white"} strokeWidth="2" strokeLinecap="round" />
                </svg>
            </AccessibilityHidden>
        </Button>
    )
}

export default FillBGBtn;